import MainLogo from "../../assests/logo.svg";
import { Toolbar, useMediaQuery, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import Button from "../Button/index";
import styles from "./Navbar.module.css";
import DrawerComp from "./Drawer";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Navbar = ({ FooterRef, FAQRef }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));
  const [activeLink, setActiveLink] = useState("home");

  const handleRegister = () => {
    const signupPath = "auth/register";
    const signupUrl = `${process.env.REACT_APP_DOMAIN}/${signupPath}`;

    window.open(signupUrl, "_blank", "noopener,noreferrer");
  };

  const handleLinkClick = (link) => {
    if (link === "home") {
      navigate("/");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (link === "howitworks") {
      navigate("/how-it-works");
    } else if (link === "about") {
      navigate("/about-us");
    } else {
      handleServicesClick(link);
    }
    setActiveLink(link);
  };

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleServicesClick = (scrollTo = "footer") => {
    if (location.pathname === "/") {
      scrollToRef(scrollTo);
      setActiveLink(scrollTo);
    } else {
      navigate("/", { state: { scrollTo } });
      setActiveLink(scrollTo);
    }
  };

  const scrollToRef = (scrollTo) => {
    if (scrollTo === "faq" && FAQRef?.current) {
      FAQRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (FooterRef?.current) {
      FooterRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    switch (location.pathname) {
      case "/":
        setActiveLink("home");
        break;
      case "/how-it-works":
        setActiveLink("howitworks");
        break;
      case "/about":
        setActiveLink("about");
        break;
      case "/faq":
        setActiveLink("faq");
        break;
      default:
        setActiveLink("");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const section = location.state.scrollTo;

      if (section === "faq" && FAQRef?.current) {
        FAQRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (FooterRef?.current) {
        FooterRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location.state, FAQRef, FooterRef]);

  return (
    <div className={`${styles.allnav} ${isScrolled ? styles.scrolled : ""}`}>
      <div className={styles.navitems}>
        <div className={styles.navcontainer}>
          <Toolbar
            sx={{
              bgcolor: "transparent",
              paddingBlock: "10px",
              width: "100%",
              paddingLeft: "0px",
              paddingRight: "0px",
              justifyContent: "space-between",
              "@media (max-width: 500px)": {
                paddingBlock: "16px",
                minHeight: "0px",
              },
              "@media (min-width: 600px)": {
                paddingLeft: "0px",
                paddingRight: "0px",
              },
            }}
          >
            <Link
              to="/"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <img src={MainLogo} className={`${styles.logo}`} alt="" />
            </Link>
            {isMatch ? (
              <>
                <DrawerComp handleServicesClick={handleServicesClick} />
              </>
            ) : (
              <>
                <div className={styles.navbar}>
                  <p
                    className={activeLink === "home" ? styles.active : ""}
                    onClick={() => handleLinkClick("home")}
                  >
                    Home
                  </p>
                  <p
                    className={activeLink === "about" ? styles.active : ""}
                    onClick={() => handleLinkClick("about")}
                  >
                    About
                  </p>
                  <p
                    className={activeLink === "howitworks" ? styles.active : ""}
                    onClick={() => handleLinkClick("howitworks")}
                  >
                    How it works
                  </p>
                  <p
                    className={activeLink === "faq" ? styles.active : ""}
                    onClick={() => handleLinkClick("faq")}
                  >
                    FAQ
                  </p>
                </div>
                <div className={styles.btnstyle}>
                  <Button
                    variant="primary"
                    color="btnfontprimary"
                    buttonSize="normal"
                    buttonName="Get Started"
                    onClick={handleRegister}
                  />
                </div>
              </>
            )}
          </Toolbar>
        </div>
      </div>
    </div>
  );
};

Navbar.propTypes = {
  servicesRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    .isRequired,
};

export default Navbar;
